import { render, staticRenderFns } from "./StartInput.vue?vue&type=template&id=bf4468b2"
import script from "./StartInput.vue?vue&type=script&lang=js"
export * from "./StartInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports